import { Box, Divider } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { RenderUnsettledUI, SmallError, SmallLoader } from 'shared/components';
import { ModalPanelBody, ModalPanelTabType } from 'redesign';
import { useGetExternalWorkersPoolDetail } from 'ogp/hooks/queryHooks/workersPools/use-get-external-workers-pool-detail';
import { WorkersPoolDetailHead } from './workers-pool-detail-head';
import { WorkersPoolFlexWorkers } from './components/workers-pool-flex-workers/workers-pool-flex-workers';
import { ServiceAgreements } from './components/service-agreements/service-agreements';

type Props = {
  id: string;
  onClose: () => void;
};

export const WorkersPoolDetail = ({ id, onClose }: Props) => {
  const { t } = useTranslation('ogp-screen-specific');
  const externalWorkersPoolDetailQuery = useGetExternalWorkersPoolDetail(id);

  if (externalWorkersPoolDetailQuery.status !== 'success') {
    return (
      <RenderUnsettledUI
        renderLoading={<SmallLoader />}
        renderError={(error) => <SmallError error={error} />}
        data={externalWorkersPoolDetailQuery}
      />
    );
  }

  const { name, description, serviceAgreements, activeWorkersCount } =
    externalWorkersPoolDetailQuery.data;

  const options: ModalPanelTabType[] = [
    {
      id: 'workers',
      tabLabel: t('flexpools.external.detail_tabs.workers'),
      element: <WorkersPoolFlexWorkers workersPoolId={id} />,
    },
    {
      id: 'service-agreements',
      tabLabel: t('flexpools.external.detail_tabs.service_agreements'),
      element: <ServiceAgreements serviceAgreements={serviceAgreements} />,
    },
  ];

  return (
    <Box height="100%" display="flex" flexDirection="column" padding={8}>
      <WorkersPoolDetailHead
        workersPoolId={id}
        name={name}
        description={description}
        activeWorkersCount={activeWorkersCount}
        onClose={onClose}
      />
      <Box mt={8} mb={8}>
        <Divider />
      </Box>
      <ModalPanelBody tabs={options} />
    </Box>
  );
};
